import { Heading, IconButton } from '@assembly-js/design-system';
import clsx from 'clsx';
import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DRAWER_ACTION_CONFIGS,
  DRAWER_IDS,
  DRAWER_LABELS,
  DrawerId,
} from 'src/context/contextBarContext';
import { useContextBar } from 'src/hooks/useContextBar';

type IconButtonIcon = ComponentProps<typeof IconButton>['icon'];

type DrawerContentHeaderProps = {
  drawerId: DrawerId;
  entityType?: 'client' | 'company';
  onAction?: () => void;
};

export const DrawerContentHeader: FC<DrawerContentHeaderProps> = ({
  drawerId,
  entityType,
  onAction,
}) => {
  const { t } = useTranslation();
  const { isMobileLayout } = useContextBar();
  const actionConfig = DRAWER_ACTION_CONFIGS[drawerId];
  const entityTerm =
    entityType === 'company'
      ? t(($) => $.company, { count: 1 })
      : t(($) => $.client, { count: 1 });
  const label =
    drawerId === DRAWER_IDS.DETAILS
      ? `${entityTerm} Details`
      : DRAWER_LABELS[drawerId];

  return (
    <div
      className={clsx(
        'flex justify-between items-center px-4 flex-shrink-0',
        isMobileLayout
          ? 'min-h-11 mt-3 mb-1 pr-3'
          : 'min-h-[60px] border border-solid border-l-0 border-r-0 border-t-0 box-border border-non-hover-border',
      )}
    >
      <Heading size={isMobileLayout ? 'lg' : 'sm'}>{label}</Heading>
      {actionConfig && onAction && (
        <IconButton
          className="hover:cursor-pointer p-1 hover:bg-secondary-hover"
          label={actionConfig.label}
          onClick={(e) => {
            e.stopPropagation();
            onAction();
          }}
          icon={actionConfig.icon as IconButtonIcon}
          variant="minimal"
        />
      )}
    </div>
  );
};
